"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCardActionStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _button = require("../../button");
var _constants = require("../constants");
var _contactCardTheme = require("../contactCardTheme");
const ContactCardActionStyled = (0, _styled.default)(_button.Button)`
    + [class*="${_constants.ccactionlabel}"] {
        margin-left: 8px;
    }
    label: ${_constants.ccactionlabel};
    margin-left: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _contactCardTheme.contactCardTheme.actionButtonLeftOffset(themeMode);
}}};
    margin-top: -4px;
`;
exports.ContactCardActionStyled = ContactCardActionStyled;
//# sourceMappingURL=ContactCardActionStyled.js.map